import { render, staticRenderFns } from "./PickupOrder.vue?vue&type=template&id=fc6a9dec&scoped=true&"
import script from "./PickupOrder.vue?vue&type=script&lang=js&"
export * from "./PickupOrder.vue?vue&type=script&lang=js&"
import style0 from "./PickupOrder.vue?vue&type=style&index=0&id=fc6a9dec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6a9dec",
  null
  
)

export default component.exports